import { Component, Injector, Input } from '@angular/core';
import { GridColumn } from '../../grids/grid-column';
import { GridConsumerComponent } from '../../grids/grid-consumer.component';
import { GridSettings } from '../../grids/grid-settings';
import { GridEvent } from '../../grids/grid/grid.component';

@Component({
  selector: 'app-data-importer-preview',
  templateUrl: './data-importer-preview.component.html',
  styleUrls: ['./data-importer-preview.component.scss']
})
export class DataImporterPreviewComponent extends GridConsumerComponent {

  columnsSettings;
  gridSettings;

  @Input() set descriptor(descriptor){
    if(descriptor){
      let columnsSettings={
        id:{hidden: true}
      }
      Object.keys(descriptor).forEach(el => {
        columnsSettings[descriptor[el].targetField]={
          label: descriptor[el].targetField,
          type: descriptor[el].type,
          filterable: true, 
          sortable: true
        }
      });
      this.columnsSettings=columnsSettings;

      const gridSettings = {
        mode: 'client',
        size: 5,
        columnsSettings: {}
      }
      Object.keys(descriptor).forEach(el => {
        if(descriptor[el].type=='OPTION')
          gridSettings.columnsSettings[descriptor[el].targetField]={selectableOptions:[{ id: 'M', label: 'Male' },{ id: 'F', label: 'Female' }]}
        else
          gridSettings.columnsSettings[descriptor[el].targetField]={}
      });
      this.gridSettings=gridSettings;
    }
  }

  reloadedItems: any[];

  constructor(protected _injector: Injector) {
    super(_injector);
  }

  /** @override */
  async _manageInputHook() {
    console.log('init this.input :>> ', this.input);
    this.reloadedItems = this.input || []
    await super.init()
  }

  /** @override */
  protected async _initColumnsHook() {
    return this.columnsSettings as { [key: string]: GridColumn }
  }

  /** @override */
  protected async _initSettingsHook(): Promise<GridSettings> {
    return this.gridSettings as GridSettings
  }

  /** @override */
  protected async _setDatasourceHook() {
    // qui ci sarebbe la chiamata al servizio rest

    return this.reloadedItems
  }

  /** @override */
  protected async _setRowCountHook(): Promise<number> {
    throw new Error("Method not implemented.");
  }

  /** @override */
  protected async _appendRowsToDatasourceHook(lastId: number) : Promise<{ [key: string]: number | string | boolean | (string | number)[] | File | File[] }[]> { 
    throw new Error("Method not implemented.");
  }

  /** @override */
  async onEventEmission(event: GridEvent){
    console.log('MasterComponent.onEventEmission :', event);
    if(event) {
      super.onEventEmission(event);
      if(![null,undefined].includes(event.rowClick)){
        console.log('click :>> ', event);
      }
    }
  }
}